import React from 'react';
import {MaterialCommunityIcons, AntDesign} from 'react-web-vector-icons';

export const Icon = MaterialCommunityIcons;
export const AntIcon = AntDesign;
